import React from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Anchor,
  Button,
  Flex,
  Card,
  Type,
} from "@ebscois/react-component-library";
import {
  AlgorithmIcon,
  AlgorithmPDFText,
  AlgorithmTitleText,
  StyledHeading,
} from "./_.styled";
import { ALGORITHM_LOGO_PDF_URL } from "../../constants/ui";
import ViewInContextMenu from "../ViewInContextMenu";
import { affordances, logAlgorithmViewed } from "../../util/analytics";

const ContentRightRailAlgorithm = ({
  label,
  algorithms = [],
  handleOpenAlgorithmPDF,
  handleAlgorithmCTA,
  isNonFreePreview,
  testId,
  slugTitle,
  slugPubType,
  isMobileDevice,
  isTabletDevice,
}) => {
  const { pathname: curSlugUrl } = useLocation();
  const algorithm = algorithms[0];

  return (
    <div data-testid={testId}>
      {algorithms.length && (
        <>
          <Flex container justify={{ content: "space-between" }}>
            <StyledHeading element="h5" fontFamily="base">
              {label}
            </StyledHeading>
            <Anchor
              linkComponent={Link}
              href={`${curSlugUrl}/algorithms`}
              aria-label={`All algorithms (${algorithms.length})`}
            >
              All ({algorithms.length})
            </Anchor>
          </Flex>

          <Card
            borderColor="gray400"
            borderBottomStyle="solid"
            borderBottomWidth="1px"
          >
            <Flex container>
              <AlgorithmIcon
                src={ALGORITHM_LOGO_PDF_URL}
                alt={algorithm.title}
                data-testid="right-rail-algorithm-icon"
              />

              <Button
                kind="anchor"
                data-testid="right-rail-algorithm"
                fontSize="sm"
                onClick={() => {
                  if (isNonFreePreview) {
                    handleAlgorithmCTA();
                  } else {
                    handleOpenAlgorithmPDF(algorithm.pdfUrl);
                    logAlgorithmViewed({
                      title: algorithm.title,
                      mediaId: algorithm.publicId,
                      type: algorithm.format,
                      affordance: affordances.RIGHT_RAIL,
                    });
                  }
                }}
              >
                <Flex container column marginBottom="lg">
                  <AlgorithmTitleText data-testid="right-rail-algorithm-title">
                    {algorithm.title}
                  </AlgorithmTitleText>
                  <AlgorithmPDFText>[PDF]</AlgorithmPDFText>
                </Flex>
              </Button>

              {algorithm?.associatedTopics && (
                <Type>
                  {ViewInContextMenu({
                    associatedTopics: algorithm.associatedTopics,
                    slugTitle,
                    slugPubType,
                    isRightRail: true,
                    isMobileDevice,
                    isTabletDevice,
                  })}
                </Type>
              )}
            </Flex>
          </Card>
        </>
      )}
    </div>
  );
};

ContentRightRailAlgorithm.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  slugTitle: PropTypes.string,
  slugPubType: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  isTabletDevice: PropTypes.bool,
  algorithms: PropTypes.arrayOf(
    PropTypes.shape({
      copyright: PropTypes.string,
      publicId: PropTypes.string,
      hasPdf: PropTypes.bool,
      associatedTopics: PropTypes.array,
      title: PropTypes.string.isRequired,
    }).isRequired
  ),
  handleOpenPDF: PropTypes.func,
};

ContentRightRailAlgorithm.displayName = "ContentRightRailAlgorithm";

export default ContentRightRailAlgorithm;
